import React, { useEffect, useState } from "react";
import './CrearEsquema.scss'
import TitleView from "../../../../components/atoms/TitleView/TitleView";
import GlovalCard from "../../../../components/atoms/GlovalCard/GlovalCard";
import InputText from "../../../../components/atoms/InputText/InputText";
import InputLista from "../../../../components/atoms/InputLista/InputLista";
import InputCalendario from "../../../../components/atoms/InputCalendario/InputCalendario";
import { useNavigate } from "react-router-dom";
import { getClients } from "../../../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion";
import { transferisServiciosIntegracion } from "../../../monitoreo/TransferirServicios/transferisServiciosIntegracion";
import { getTipo, getTurnos, getTurnosEnGeneral } from "../EsquemasIntegracion";
import { extraerHoraDate, formateoBasico } from "../../../../utilities/formateos";
import Button from "../../../../components/atoms/Button/Button";
import Swal from "sweetalert2";
import { crearEsquemaIntegracion } from "./crearEsquemaIntegracion";


const CrearEsquema = () => {
    const navigate = useNavigate()
    const [clientes, setClientes] = useState([])
    const [routes, setRoutes] = useState([])
    const [route, setRoute] = useState(null)
    const [cliente, setCliente] = useState(null)
    const [turnos, setTurnos] = useState([])
    const [turno, setTurno] = useState([])
    const [tipos, setTipos] = useState([])
    const [tipo, setTipo] = useState([])
    const [fechaInicio, setFechaInicio] = useState(formateoBasico(new Date()))
    const [fechaFin, setFechaFin] = useState(formateoBasico(new Date()))
    const [horaInicio, setHoraInicio] = useState(extraerHoraDate(new Date()))
    const [horaFin, setHoraFin] = useState(extraerHoraDate(new Date()))
    const [lunes, setLunes] = useState(false)
    const [martes, setMartes] = useState(false)
    const [miercoles, setMiercoles] = useState(false)
    const [jueves, setJueves] = useState(false)
    const [viernes, setViernes] = useState(false)
    const [sabado, setSabado] = useState(false)
    const [domingo, setDomingo] = useState(false)
    const [fechaActual,setFechaActual] = useState(formateoBasico(new Date()))
     const [estructuraDinamica,setEstructuraDinamica] = useState()
    useEffect(() => {
        getClients(setClientes)
        getTurnosEnGeneral(setTurnos)
        getTipo(setTipos)
    }, [])
    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRoutes)
        }
    }, [cliente])

    const crearEsquema = ()=>
    {
        if(cliente&&route&&tipo&&turno&&fechaInicio&&fechaFin&&horaInicio&&horaFin)
        {
            const data = {
                cliente:cliente.code,
                route:route.code,
                tipo:tipo.code,
                turno:turno.code,
                fecha_inicio:fechaInicio,
                fecha_fin:fechaFin,
                hora_inicio:fechaActual +" "+horaInicio,
                hora_fin:fechaActual+" "+horaFin,
                lunes:lunes?"1":"0",
                martes:martes?"1":"0",
                miercoles:miercoles?"1":"0",
                jueves:jueves?"1":"0",
                viernes:viernes?"1":"0",
                sabado:sabado?"1":"0",
                domingo:domingo?"1":"0",
                esDinamica:estructuraDinamica?"1":"0"
            }
            crearEsquemaIntegracion.agregarEsquema(data,navigate)
    

        }
        else{
            Swal.fire({
                icon: 'error',   // Icono de error
                text: 'Ingrese todos los campos obligatorios', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
              });
        }
        
    }
    return (
        <div className="CrearEsquema">
            <TitleView title={"Crear esquema"}></TitleView>
            <GlovalCard>
                <div className="input-container">
                    <InputLista titulo={"Cliente"} value={cliente} onChange={(e) => { setCliente(e.value) }} options={clientes} className={"input"}></InputLista>
                    <InputLista titulo={"Ruta"} value={route} onChange={(e) => { setRoute(e.value) }} options={routes} className={"input"}></InputLista>
                    <InputLista options={tipos} value={tipo} onChange={(e) => { setTipo(e.value) }} titulo={"Tipo de servicio"} className={"input"}></InputLista>
                    <InputLista options={turnos} value={turno} onChange={(e) => { setTurno(e.value) }} titulo={"Turno"} className={"input"}></InputLista>
                    <InputCalendario onChange={(e)=>{setFechaInicio(e.target.value)}} value={fechaInicio} titulo={"Fecha de inicio"} className={"input"}></InputCalendario>
                    <InputCalendario onChange={(e)=>{setFechaFin(e.target.value)}} value={fechaFin} titulo={"Fecha de fin"} className={"input"}></InputCalendario>
                    <InputText onChange={(e)=>{setHoraInicio(e.target.value)}} obligatorio value={horaInicio} title="Hora inicio" type="time" className={"input"}></InputText>
                    <InputText onChange={(e)=>{setHoraFin(e.target.value)}} obligatorio value={horaFin} title="Hora fin" type="time" className={"input"}></InputText>
                </div>
                <TitleView title={"Seleccione los dias del esquema : "}></TitleView>
              <div className="container-inputsDias">
                <div className="input-SELECTS">
                    <div className="check-container"><div className="contenido">L</div>
                        <input onChange={(e) => { setLunes(e.target.checked) }} checked={lunes ? lunes : false} type="checkbox"></input>
                    </div>
                    <div className="check-container"><div className="contenido">M</div>
                        <input onChange={(e) => { setMartes(e.target.checked) }} checked={martes ? martes : false} type="checkbox"></input>
                    </div>
                    <div className="check-container"><div className="contenido">M</div>
                        <input onChange={(e) => { setMiercoles(e.target.checked) }} checked={miercoles ? miercoles : false} type="checkbox"></input>
                    </div>
                    <div className="check-container"><div className="contenido">J</div>
                        <input onChange={(e) => { setJueves(e.target.checked) }} checked={jueves ? jueves : false} type="checkbox"></input>
                    </div>
                    <div className="check-container"><div className="contenido">V</div>
                        <input onChange={(e) => { setViernes(e.target.checked) }} checked={viernes ? viernes : false} type="checkbox"></input>
                    </div>
                    <div className="check-container"><div className="contenido">S</div>
                        <input onChange={(e) => { setSabado(e.target.checked) }} checked={sabado ? sabado : false} type="checkbox"></input>
                    </div>
                    <div className="check-container"><div className="contenido">D</div>
                        <input onChange={(e) => { setDomingo(e.target.checked) }} checked={domingo ? domingo : false} type="checkbox"></input>
                    </div>
                </div>
                <b style={{marginLeft:"20px"}}><label htmlFor="">ES DINAMICA <input type="checkbox" checked={estructuraDinamica?true:false} onChange={(e)=>{setEstructuraDinamica(e.target.checked)}}></input></label></b>

                <Button  onClick={()=>{crearEsquema()}} className={"buttonSubir"}>Crear</Button>
              </div>

            </GlovalCard>
        </div>
    )
}
export default CrearEsquema